var _circle, _rect, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62, _circle63, _circle64, _circle65, _circle66, _circle67, _circle68, _circle69;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeapFrog(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 36.5,
    r: 35,
    fill: "white",
    stroke: "#45657B",
    strokeWidth: 3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 16.5,
    width: 39,
    height: 39,
    rx: 0.5,
    stroke: "#45657B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.7143,
    cy: 50.2856,
    r: 2.35714,
    stroke: "#45657B"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.7143,
    cy: 50.2856,
    r: 2.35714,
    stroke: "#45657B"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.7143,
    cy: 50.2856,
    r: 2.35714,
    stroke: "#45657B"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.7143,
    cy: 50.2856,
    r: 2.35714,
    stroke: "#45657B"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.2381,
    cy: 50.2856,
    r: 2.35714,
    stroke: "#45657B"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.2381,
    cy: 50.2856,
    r: 2.35714,
    stroke: "#45657B"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.2381,
    cy: 50.2856,
    r: 2.35714,
    stroke: "#45657B"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.2381,
    cy: 50.2856,
    r: 2.35714,
    stroke: "#45657B"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.7619,
    cy: 50.2856,
    r: 2.35714,
    stroke: "#45657B"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.7619,
    cy: 50.2856,
    r: 2.35714,
    stroke: "#45657B"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.7619,
    cy: 50.2856,
    r: 2.35714,
    stroke: "#45657B"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.7619,
    cy: 50.2856,
    r: 2.35714,
    stroke: "#45657B"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.2857,
    cy: 50.2856,
    r: 2.35714,
    fill: "#45657B"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.2857,
    cy: 50.2856,
    r: 2.35714,
    stroke: "#45657B"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.2857,
    cy: 50.2856,
    r: 2.35714,
    stroke: "#45657B"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.2857,
    cy: 50.2856,
    r: 2.35714,
    stroke: "#45657B"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.2857,
    cy: 50.2856,
    r: 2.35714,
    stroke: "#45657B"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.7143,
    cy: 40.7619,
    r: 2.35714,
    stroke: "#45657B"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.7143,
    cy: 40.7619,
    r: 2.35714,
    stroke: "#45657B"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.7143,
    cy: 40.7619,
    r: 2.35714,
    stroke: "#45657B"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.7143,
    cy: 40.7619,
    r: 2.35714,
    stroke: "#45657B"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.2381,
    cy: 40.7619,
    r: 2.35714,
    stroke: "#45657B"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.2381,
    cy: 40.7619,
    r: 2.35714,
    stroke: "#45657B"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.2381,
    cy: 40.7619,
    r: 2.35714,
    stroke: "#45657B"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.2381,
    cy: 40.7619,
    r: 2.35714,
    stroke: "#45657B"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.7619,
    cy: 40.7619,
    r: 2.35714,
    fill: "#45657B"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.7619,
    cy: 40.7619,
    r: 2.35714,
    stroke: "#45657B"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.7619,
    cy: 40.7619,
    r: 2.35714,
    stroke: "#45657B"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.7619,
    cy: 40.7619,
    r: 2.35714,
    stroke: "#45657B"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.7619,
    cy: 40.7619,
    r: 2.35714,
    stroke: "#45657B"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.2857,
    cy: 40.7619,
    r: 2.35714,
    stroke: "#45657B"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.2857,
    cy: 40.7619,
    r: 2.35714,
    stroke: "#45657B"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.2857,
    cy: 40.7619,
    r: 2.35714,
    stroke: "#45657B"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.2857,
    cy: 40.7619,
    r: 2.35714,
    stroke: "#45657B"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.7143,
    cy: 31.238,
    r: 2.35714,
    stroke: "#45657B"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.7143,
    cy: 31.238,
    r: 2.35714,
    stroke: "#45657B"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.7143,
    cy: 31.238,
    r: 2.35714,
    stroke: "#45657B"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.7143,
    cy: 31.238,
    r: 2.35714,
    stroke: "#45657B"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.2381,
    cy: 31.238,
    r: 2.35714,
    fill: "#45657B"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.2381,
    cy: 31.238,
    r: 2.35714,
    stroke: "#45657B"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.2381,
    cy: 31.238,
    r: 2.35714,
    stroke: "#45657B"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.2381,
    cy: 31.238,
    r: 2.35714,
    stroke: "#45657B"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.2381,
    cy: 31.238,
    r: 2.35714,
    stroke: "#45657B"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.7619,
    cy: 31.238,
    r: 2.35714,
    stroke: "#45657B"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.7619,
    cy: 31.238,
    r: 2.35714,
    stroke: "#45657B"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.7619,
    cy: 31.238,
    r: 2.35714,
    stroke: "#45657B"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.7619,
    cy: 31.238,
    r: 2.35714,
    stroke: "#45657B"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.2857,
    cy: 31.238,
    r: 2.35714,
    stroke: "#45657B"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.2857,
    cy: 31.238,
    r: 2.35714,
    stroke: "#45657B"
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.2857,
    cy: 31.238,
    r: 2.35714,
    stroke: "#45657B"
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.2857,
    cy: 31.238,
    r: 2.35714,
    stroke: "#45657B"
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.7143,
    cy: 21.7143,
    r: 2.35714,
    fill: "#45657B"
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.7143,
    cy: 21.7143,
    r: 2.35714,
    stroke: "#45657B"
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.7143,
    cy: 21.7143,
    r: 2.35714,
    stroke: "#45657B"
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.7143,
    cy: 21.7143,
    r: 2.35714,
    stroke: "#45657B"
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.7143,
    cy: 21.7143,
    r: 2.35714,
    stroke: "#45657B"
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.2381,
    cy: 21.7143,
    r: 2.35714,
    stroke: "#45657B"
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.2381,
    cy: 21.7143,
    r: 2.35714,
    stroke: "#45657B"
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.2381,
    cy: 21.7143,
    r: 2.35714,
    stroke: "#45657B"
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.2381,
    cy: 21.7143,
    r: 2.35714,
    stroke: "#45657B"
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.7619,
    cy: 21.7143,
    r: 2.35714,
    stroke: "#45657B"
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.7619,
    cy: 21.7143,
    r: 2.35714,
    stroke: "#45657B"
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.7619,
    cy: 21.7143,
    r: 2.35714,
    stroke: "#45657B"
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.7619,
    cy: 21.7143,
    r: 2.35714,
    stroke: "#45657B"
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.2857,
    cy: 21.7143,
    r: 2.35714,
    stroke: "#45657B"
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.2857,
    cy: 21.7143,
    r: 2.35714,
    stroke: "#45657B"
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.2857,
    cy: 21.7143,
    r: 2.35714,
    stroke: "#45657B"
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.2857,
    cy: 21.7143,
    r: 2.35714,
    stroke: "#45657B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeapFrog);
export default __webpack_public_path__ + "static/media/LeapFrog.ca2415f4484264196c2a5173f7f5c356.svg";
export { ForwardRef as ReactComponent };